import React, { memo } from 'react';

import { Box } from '@mui/material';

import { dotSeparatorStyles } from './DotSeparator.styles';

const DotSeparator = () => <Box sx={dotSeparatorStyles} />;

export default memo(DotSeparator);
